import React, { useState } from 'react'

export default function TipBox({ title, children, collapsible = false }) {
  const [open, setOpen] = useState(false)

  if (collapsible) {
    return (
      <div className="tip-box tip-box-collapsible">
        <button className="tip-box-toggle" onClick={() => setOpen(v => !v)}>
          <span className="tip-box-title">{title}</span>
          <span className="tip-box-chevron">{open ? '▲' : '▼'}</span>
        </button>
        {open && <div className="tip-box-body">{children}</div>}
      </div>
    )
  }

  return (
    <div className="tip-box">
      {title && <p className="tip-box-title">{title}</p>}
      {children}
    </div>
  )
}
